import type { FC } from 'react';

import { FlourishChartRendering } from '@sitecore/types/FlourishChart';
import Script from 'next/script';

const FlourishChart: FC<FlourishChartRendering> = ({ fields }) => {
  const id = fields?.visualizationId?.value;

  if (!id) return null;

  return (
    <div className="flourish-embed flourish-chart" data-src={`visualisation/${id}`}>
      <Script strategy="afterInteractive" id="flourish" src="https://public.flourish.studio/resources/embed.js" />
    </div>
  );
};

export { FlourishChart };
export default FlourishChart;
